import {
  CancelOrder,
  CheckOrder,
  GetHistoryOrderForm,
  GetHistoryOrderList,
  GetOpenOrderForm,
  GetOpenOrderList,
  GetTradeAmountMax,
  GetTradeForm,
  GetTradeInsertForm,
  GetTradeLast24HList,
  GetTradeList,
  TradeInsertInitial,
} from "./api";

import http from "config/http";

const tradeApi = {
  getTradeInsertForm: async ({
    sideId,
    basketId,
    coinDestinationId,
    coinSourceId,
  }) =>
    await http.get(
      GetTradeInsertForm({
        basketId,
        sideId,
        coinDestinationId,
        coinSourceId,
      })
    ),

  getTradeAmountMax: async ({
    basketId,
    sideId,
    coinDestinationId,
    coinSourceId,
    brokerId
  }) =>
    await http.get(
      GetTradeAmountMax({
        basketId,
        sideId,
        coinDestinationId,
        coinSourceId,
        brokerId
      })
    ),

  tradeInsertInitial: async (body) => await http.post(TradeInsertInitial, body),

  getTradeForm: async () => await http.get(GetTradeForm),

  getTradeLast24HList: async () => await http.get(GetTradeLast24HList),

  getTradeList: async ({
    brokerId,
    basketId,
    coinSourceId,
    coinDestinationId,
    sideId,
    stateId,
    typeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  }) => await http.get(GetTradeList({
    brokerId,
    basketId,
    coinSourceId,
    coinDestinationId,
    sideId,
    stateId,
    typeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  })),

  getHistoryOrderForm: async () => await http.get(GetHistoryOrderForm),

  getHistoryOrderList: async ({
    brokerId,
    basketId,
    coinSourceId,
    coinDestinationId,
    sideId,
    stateId,
    typeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  }) => await http.get(GetHistoryOrderList({
    brokerId,
    basketId,
    coinSourceId,
    coinDestinationId,
    sideId,
    stateId,
    typeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  })),

  cancelOrder: async (body) => await http.post(CancelOrder, body),

  checkOrder: async (body) => await http.post(CheckOrder, body),

  getOpenOrderList: async ({
    brokerId,
    basketId,
    coinSourceId,
    coinDestinationId,
    sideId,
    typeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  }) => await http.get(GetOpenOrderList({
    brokerId,
    basketId,
    coinSourceId,
    coinDestinationId,
    sideId,
    typeId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  })),

  getOpenOrderForm: async () => await http.get(GetOpenOrderForm),
};

export default tradeApi;
